import api from './baseAPIService';

// Exam CRUD operations
export const createExam = async (examData) => {
  try {
    const response = await api.post('/exams/', examData);
    return response.data;
  } catch (error) {
    console.error('API Error:', error.response?.data || error);
    throw error;
  }
};

export const getExams = async () => {
  try {
    const response = await api.get('/exams/');
    return response.data;
  } catch (error) {
    console.error('API Error:', error.response?.data || error);
    throw error;
  }
};

export const getAllExamSubcategoriesWithCounts = async () => {
  try {
    // Hole zuerst alle Prüfungen
    const examsResponse = await api.get('/exams/');
    const exams = examsResponse.data;

    // Hole dann alle Prüfungsteile mit Zählungen
    const subcategoriesResponse = await api.get('/exams/subcategories/all/with-counts');
    const subcategoriesWithCounts = subcategoriesResponse.data;

    // Gruppiere die Prüfungsteile nach Prüfungen
    return exams.map(exam => ({
      ...exam,
      subcategories: subcategoriesWithCounts.filter(sub => sub.exam_id === exam.id)
    }));
  } catch (error) {
    console.error('API Error:', error.response?.data || error);
    throw error;
  }
};

export const getExam = async (examId) => {
  try {
    const response = await api.get(`/exams/${examId}`);
    return response.data;
  } catch (error) {
    console.error('API Error:', error.response?.data || error);
    throw error;
  }
};

export const updateExam = async (examId, examData) => {
  try {
    const response = await api.put(`/exams/${examId}`, examData);
    return response.data;
  } catch (error) {
    console.error('API Error:', error.response?.data || error);
    throw error;
  }
};

export const deleteExam = async (examId) => {
  try {
    const response = await api.delete(`/exams/${examId}`);
    return response.data;
  } catch (error) {
    console.error('API Error:', error.response?.data || error);
    throw error;
  }
};

// Exam Subcategory operations
export const createExamSubcategory = async (subcategoryData) => {
  try {
    const response = await api.post('/exams/subcategories', subcategoryData);
    return response.data;
  } catch (error) {
    console.error('API Error:', error.response?.data || error);
    throw error;
  }
};

export const updateExamSubcategory = async (subcategoryId, subcategoryData) => {
  try {
    const response = await api.put(`/exams/subcategories/${subcategoryId}`, subcategoryData);
    return response.data;
  } catch (error) {
    console.error('API Error:', error.response?.data || error);
    throw error;
  }
};

export const deleteExamSubcategory = async (subcategoryId) => {
  try {
    const response = await api.delete(`/exams/subcategories/${subcategoryId}`);
    return response.data;
  } catch (error) {
    console.error('API Error:', error.response?.data || error);
    throw error;
  }
};

export const getExamSubcategory = async (subcategoryId) => {
  try {
    const response = await api.get(`/exams/subcategories/${subcategoryId}`);
    return response.data;
  } catch (error) {
    console.error('API Error:', error.response?.data || error);
    throw error;
  }
};

// Question Mapping operations
export const getExamQuestions = async (subcategoryId) => {
  try {
    const response = await api.get(`/exams/subcategories/${subcategoryId}/questions`);
    return response.data;
  } catch (error) {
    console.error('API Error:', error.response?.data || error);
    throw error;
  }
};

export const getExamQuestionsWithStats = async (subcategoryId) => {
  try {
    const response = await api.get(`/exams/subcategories/${subcategoryId}/questions-with-stats`);
    return response.data;
  } catch (error) {
    console.error('Error loading exam questions with stats:', error);
    throw error;
  }
};

export const addQuestionToExam = async (mappingData) => {
  try {
    const response = await api.post('/exams/questions', mappingData);
    return response.data;
  } catch (error) {
    console.error('API Error:', error.response?.data || error);
    throw error;
  }
};

export const removeQuestionFromExam = async (mappingId) => {
  try {
    const response = await api.delete(`/exams/questions/${mappingId}`);
    return response.data;
  } catch (error) {
    console.error('API Error:', error.response?.data || error);
    throw error;
  }
};

export const updateQuestionPosition = async (mappingId, position) => {
  try {
    const response = await api.put(`/exams/questions/${mappingId}/position`, { position });
    return response.data;
  } catch (error) {
    console.error('API Error:', error.response?.data || error);
    throw error;
  }
};

export const getAllExamStatistics = async () => {
    try {
        const response = await api.get('/exams/statistics/all');
        return response.data;
    } catch (error) {
        console.error('Error fetching exam statistics:', error);
        throw error;
    }
};
